module.exports = __webpack_public_path__ + "static/media/4_3.a5ecf6b6.png";